<template>
  <div class="group-users">
    <SidebarLayout3 :breadcrumb="breadcrumb" :pageTitle="pageTitle">
      <!-- BARRA LATERAL -->
      <template #sidebar>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <Heading>Ações da página</Heading>
          <!-- CADASTRAR -->
          <Button
            :disabled="checkDisableSave()"
            tooltipText="Necessário preencher o nome do grupo e selecionar suas funcionalidades."
            class="page-actions--button"
            @click="groupUserId == null ? saveGroupUser() : editGroupUser()"
          >
            Salvar
          </Button>
          <!-- LISTAGEM DE GRUPO DE USUÁRIOS -->
          <Button
            link="/grupos-de-usuarios"
            element="router-link"
            class="page-actions--button"
            layout="outline"
          >
            Voltar sem salvar
          </Button>
          <!-- EXCLUIR -->
          <Button
            variation="error"
            class="page-actions--button"
            @click="showAlertModal = true"
          >
            Excluir grupo
          </Button>
        </SidebarBlock>
      </template>
      <!-- CONTEÚDO -->
      <template #content class="form">
        <Heading class="form--heading" level="2">Informações do grupo</Heading>
        <!-- NOME DO GRUPO -->
        <FormInput
          v-model="form.name"
          label="Nome do grupo"
          placeholder="Insira um nome"
          class="form--input-name"
        />
        <!-- DESCRIÇÃO DO GRUPO -->
        <Textarea
          v-model="form.description"
          :counter="true"
          :maxlength="80"
          label="Descrição do grupo"
          class="form--textarea-description"
        />
        <SeparateLine :left="0" :right="0" :bottom="45" :top="0" />
        <!-- USUÁRIOS -->
        <Heading class="form--heading" level="2">
          Selecione usuários para este grupo
        </Heading>
        <SelectionBox
          v-model="form.users"
          :list="users"
          titleFirstBox="Usuários do grupo"
          titleSecondBox="Usuários selecionados"
          class="form--users"
        />
        <!-- FUNCIONALIDADES -->
        <Heading class="form--heading" level="2">
          Selecione quais funcionalidades este grupo de usuários terá acesso
        </Heading>
        <PmwDatatableTreeview
          v-model="form.functions"
          :items="functions.list"
          :headers="functions.headers"
          :hasRowCheckbox="true"
          :selectFolders="true"
          :selectFoldersAutomatic="false"
          class="form--functions"
        />
        <!-- CRIAÇÃO -->
        <div class="form--created" v-if="form.created">
          <Paragraph>Grupo criado em</Paragraph>
          <Paragraph>{{ form.created }}</Paragraph>
        </div>
        <SeparateLine :left="0" :right="0" :bottom="45" :top="0" />
        <!-- AÇÕES -->
        <div class="form--actions">
          <!-- CANCELAR -->
          <Button
            :link="`/grupos-de-usuarios`"
            element="router-link"
            layout="outline"
            size="large"
          >
            Cancelar
          </Button>
          <!-- SALVAR -->
          <Button
            :disabled="checkDisableSave()"
            tooltipText="Necessário preencher o nome do grupo e selecionar suas funcionalidades."
            popperPosition="top"
            tooltipMinWidth="230"
            popperStrategy="absolute"
            size="large"
            @click="groupUserId == null ? saveGroupUser() : editGroupUser()"
          >
            Salvar
          </Button>
        </div>
      </template>
    </SidebarLayout3>
    <AlertModal
      v-model="showAlertModal"
      title="Excluir grupo de usuários"
      @alert-modal-confirm="inativeGroupUsers"
      @alert-modal-cancel="cancelInativeGroupUsers"
    >
      <template #text>
        Ao excluir um grupo, os usuários que pertencem <br />
        somente a este grupo ficarão sem acesso. <br />
        Você tem certeza que quer fazer isso?
      </template>
    </AlertModal>
  </div>
</template>

<script>
import SidebarLayout3 from '@/layouts/SidebarLayout3'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import Button from '@solucoes/components-lib-tmp/src/components/elements/Button'
import FormInput from '@solucoes/components-lib-tmp/src/components/elements/FormInput'
import Textarea from '@solucoes/components-lib-tmp/src/components/elements/Textarea'
import SeparateLine from '@solucoes/components-lib-tmp/src/components/elements/SeparateLine'
import PmwDatatableTreeview from '@solucoes/components-lib-tmp/src/components/patterns/PmwDatatableTreeview'
import SelectionBox from '@/components/_base/patterns/SelectionBox'
import Paragraph from '@solucoes/components-lib-tmp/src/components/elements/Paragraph'
import AlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'

import { formatDate } from '@/helpers/date'

export default {
  name: 'GroupUsersCreate',
  components: {
    SidebarLayout3,
    SidebarBlock,
    Heading,
    Button,
    FormInput,
    Textarea,
    SeparateLine,
    PmwDatatableTreeview,
    SelectionBox,
    Paragraph,
    AlertModal
  },
  data() {
    return {
      breadcrumb: [
        {
          label: 'Configurações',
          url: '',
          isSpa: false /** se deve ser um link para o site novo ou antigo  */
        },
        {
          label: 'Grupos de usuários',
          url: '/grupos-de-usuarios',
          isSpa: true /** se deve ser um link para o site novo ou antigo  */
        },
        {
          label: 'Criar novo grupo',
          url: '/grupos-de-usuarios/criar',
          isSpa: true /** se deve ser um link para o site novo ou antigo  */
        }
      ],
      groupUserId: null,
      pageTitle: 'Criar novo grupo',
      /** Lista dos usuários */
      users: [],
      /** Dados para o formmulário */
      form: {
        name: null,
        description: '',
        users: [],
        functions: [],
        created: null
      },
      /** Dados para a listagem de funcionalidades */
      functions: {
        list: [],
        headers: [
          {
            label: 'Descrição',
            property: 'descricao'
          }
        ]
      },
      /** Mostrar modais */
      showAlertModal: false
    }
  },
  async created() {
    /** Pegar usuários */
    await this.getUsers()
    /** Pegar funcionalidades */
    await this.getFunctions()
    /** Se for edição, pegar o ID e o grupo de usuários */
    this.groupUserId = this.$route.params.id || null
    if (this.groupUserId !== null) {
      this.getGroupUsers()
    }
  },
  methods: {
    /** Se for edição, buscar grupo de usuários */
    getGroupUsers() {
      this.$user
        .getGroupUsers(this.groupUserId)
        .then((response) => {
          /** Pegar nome */
          this.form.name = response.data.nome
          this.pageTitle = `Editando ${response.data.nome}`
          this.breadcrumb[
            this.breadcrumb.length - 1
          ].label = `Editando ${response.data.nome}`

          /** Pegar data de criação */
          this.form.created = formatDate(
            new Date(response.data.dataCriacao),
            'dd/MM/yyyy HH:mm:ss'
          )

          /** Pegar descrição */
          this.form.description = response.data.descricao

          /** Pegar usuários pelo ID */
          const users = this.users.filter((item) =>
            response.data.usuarios.includes(item.codigo)
          )
          this.form.users = users

          /** Pegar usuários não selecionados */
          const usersFilters = this.users.filter(
            (item) => !response.data.usuarios.includes(item.codigo)
          )
          this.users = usersFilters

          /** Pegar funcionalidades pela chave */
          this.formatSelectedDataTreeview(
            this.functions.list,
            response.data.funcionalidades
          )
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Houve um erro ao buscar o grupo de usuários'
          })
          /** Redirecionar para a listagem de grupos de usuários */
          setTimeout(() => {
            this.$router.push({
              path: '/grupos-de-usuarios'
            })
          }, 1000)
        })
    },

    /** Pegar listagem de usuários */
    async getUsers() {
      await this.$user
        .getUsers()
        .then((response) => {
          /** Remover itens excluídos e ordenar pelo nome */
          let data = response.data.sort((a, b) =>
            a.nome > b.nome ? 1 : b.nome > a.nome ? -1 : 0
          )
          /** Formatar dados */
          data = data.map((item) => {
            item.id = item.codigo
            item.text = item.nome
            return item
          })
          this.users = data
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Houve um erro ao buscar os usuários'
          })
        })
    },

    /** Pegar listagem de funções */
    async getFunctions() {
      await this.$user
        .getUsersFunctions()
        .then((response) => {
          this.functions.list = this.formatDataTreeview(response.data)
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Houve um erro ao buscar as funcionalidades'
          })
        })
    },

    /** Formatar listagem de itens do treeview */
    formatDataTreeview(arr, parent = null) {
      return arr.map((item) => {
        item.parent = parent
        const children = item.subItens
        delete item.subItens
        if (children && children.length) {
          item.pmTreeViewOpened = true
          item.children = children
          this.formatDataTreeview(item.children, item.chave)
        }
        return item
      })
    },

    /** Formatar dados selecionados para o treeview */
    formatSelectedDataTreeview(list, itemsSelecteds) {
      return list.map(({ children = [], ...item }) => {
        if (itemsSelecteds.includes(item.chave)) {
          /** Adicionar dados selecionados à listagem */
          this.form.functions.push({
            chave: item.chave,
            descricao: item.descricao,
            parent: item.parent
          })
        }
        /** Se o dados possuir filhos, executar a função recursivamente */
        if (children.length)
          item.children = this.formatSelectedDataTreeview(
            children,
            itemsSelecteds
          )
        return item
      })
    },

    /** Salvar grupo de usuários */
    saveGroupUser() {
      const data = {
        nome: this.form.name,
        descricao: this.form.description,
        ativo: true,
        usuarios: this.formatUsers(),
        funcionalidades: this.formatFunctions()
      }
      this.$user
        .createGroupUsers(data)
        .then(() => {
          /** Feedback de sucesso */
          this.$bus.$emit('show-alert-chip', {
            message: 'Grupo de usuários criado com sucesso!'
          })
          /** Redirecionar para a listagem de grupos de usuários */
          setTimeout(() => {
            this.$router.push({
              path: '/grupos-de-usuarios'
            })
          }, 1000)
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.messages
          })
        })
    },

    /** Editar grupo de usuários */
    editGroupUser() {
      const data = {
        codigo: parseInt(this.groupUserId),
        nome: this.form.name,
        descricao: this.form.description,
        ativo: true,
        usuarios: this.formatUsers(),
        funcionalidades: this.formatFunctions()
      }
      this.$user
        .editGroupUsers(data)
        .then(() => {
          /** Feedback de sucesso */
          this.$bus.$emit('show-alert-chip', {
            message: 'Grupo de usuários editado com sucesso!'
          })
          /** Redirecionar para a listagem de grupos de usuários */
          setTimeout(() => {
            this.$router.push({
              path: '/grupos-de-usuarios'
            })
          }, 1000)
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.messages
          })
        })
    },

    /** Formatar dados dos usuários selecionados */
    formatUsers() {
      const data = this.form.users.map((item) => {
        const id = item.codigo
        return id
      })
      return data
    },

    /** Formatar dados das funcionalidades selecionadas */
    formatFunctions() {
      const parents = []
      /** Formatar dados */
      const data = this.form.functions.map((item) => {
        const chave = item.chave
        if (item.parent !== null) {
          parents.push(item.parent)
        }
        return chave
      })
      /** Mesclar chaves e chaves pais removendo duplicados */
      return data.concat(parents).filter((v, i, a) => a.indexOf(v) === i)
    },

    /** Inativar grupos de usuarios */
    inativeGroupUsers() {
      this.$user
        .inativeGroupUsers(this.groupUserId)
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Grupo excluído com sucesso.'
          })
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Houve um erro ao excluir o grupo.'
          })
        })
        .finally(() => {
          /** Redirecionar para a listagem de grupos de usuários */
          setTimeout(() => {
            this.$router.push({
              path: '/grupos-de-usuarios'
            })
          }, 1000)
        })
    },

    /** Cancelar inativação dos grupos de usuarios */
    cancelInativeGroupUsers() {
      this.showAlertModal = false
    },

    /** Habilitar/desabilitar o botão "Salvar" */
    checkDisableSave() {
      const validateName = this.form.name !== null && this.form.name.length > 2
      const validateFunctions = this.formatFunctions().length > 0
      return validateName && validateFunctions ? false : true
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
}
.group-users {
  .page-actions {
    .heading {
      margin-bottom: 30px;
    }
    &--button {
      width: 100%;
      cursor: pointer;

      & + .page-actions--button {
        margin-top: 10px;
      }
    }
  }
  .form {
    &--heading {
      color: $pmw-gray-darkest;
      font-weight: 300;
      margin-bottom: 40px;
    }
    &--input-name {
      max-width: 276px;
      margin-bottom: 30px;
    }
    &--textarea-description {
      max-width: 440px;
      margin-bottom: 55px;
    }
    &--users {
      margin-bottom: 40px;
    }
    &--functions {
      margin-bottom: 50px;
    }
    &--created {
      margin-bottom: 25px;
      .paragraph {
        line-height: 21px;
        color: $pmw-gray-dark;
        margin-bottom: 10px;
      }
    }
    &--actions {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
</style>
